import createWorkScheduleReducer from '../../js/administration/workSchedule/workScheduleReducer'
import createLicensesReducer from '../../js/administration/licenses/licenseReducer'
import {combineReducers} from 'redux'
import createLoggedInUserReducer from '../../js/loggedInUser/reducer'
import createLicenseCountDownTipReducer from '../../js/components/licenseCountDownTip/reducer'
import createSupportReducer from '../../js/support/supportForm/reducer'

export default (initAppData) => {
    return combineReducers({
        loggedInUser: createLoggedInUserReducer(initAppData),
        workSchedule: createWorkScheduleReducer(initAppData),
        licenses: createLicensesReducer(initAppData),
        licenseCountDownTip: createLicenseCountDownTipReducer(initAppData),
        support: createSupportReducer(initAppData),
    })
}


// WEBPACK FOOTER //
// ./web/actiplans/js/reducer.js